import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F053196C-66BC-4D0D-B75F-24773CA618E5
 * name pine-tree
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pine-tree.svg
 * tags
 * - Holiday 
 * - Nature 
 * - Places 
 * - Agriculture 
 */
export const PineTreeIcon = createSvgIcon(<><path d="M10,21V18H3L8,13H5L10,8H7L12,3L17,8H14L19,13H16L21,18H14V21H10Z" /></>, 'PineTreeIcon');
export default PineTreeIcon